import { render } from "./icon-typicon.vue?vue&type=template&id=53bb34f4"
import script from "./icon-typicon.vue?vue&type=script&lang=js"
export * from "./icon-typicon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__